export default function P3() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="256"
      height="464"
      fillRule="evenodd"
      clipRule="evenodd"
      imageRendering="optimizeQuality"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      version="1.1"
      viewBox="0 0 256 464"
      xmlSpace="preserve"
    >
      <defs>
        <clipPath clipRule="nonzero">
          <path d="M1515 6513H223V5277h533v429c0 74 60 134 134 134h625z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M3334 6513h-722v-673h722z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M2612 6513H1515v-673h83v673z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M2612 6513H1598v-673h1014z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M4626 6513H3334h625v-676c8 2 18 3 27 3h640z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M3959 6513h-56v-701c16 13 35 21 56 26v676z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M3904 6513h-570v-673h10c103 0 88-65 88-188v-375h420v429c0 43 20 81 52 106z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M3344 5840h-10v-563h98v375c0 123 15 188-88 188z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M6445 6513h-722v-673h722z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M5723 6513H4626v-673h83v673z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M5723 6513H4709v-673h1014z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M7820 5277h2305v1236h56V5277h-56z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M7737 6513H6446h624V5277h750-84v1236z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M7070 6513h-56V5277h56z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M7015 6513h-570v-673c72-3 129-62 129-134v-429h441z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M6445 5840v-563h129v429c0 72-57 131-129 134z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M10126 6513H8834V5277h1292z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M8834 6513H7737V5277h83v1236z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M8834 6513H7820V5277h1014z"></path>
        </clipPath>
      </defs>
      <g display="inline">
        <path
          fillRule="evenodd"
          d="M8203 4182L8328 4189 8300 4436 8183 4431z"
          className="p3-fil21"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
          transform="matrix(.096 0 0 .096 -667.373 -95.97)"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M129.116 327.378l18.624 8.544c1.248.576 1.824 2.016 1.536 3.264H116.54l1.248-11.903 11.423.095z"
          className="p3-fil22"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          d="M7968 4182L8093 4189 8065 4436 7948 4431z"
          className="p3-fil21"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
          transform="matrix(.096 0 0 .096 -667.373 -95.97)"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M106.557 327.378l18.623 8.544c1.248.576 1.824 2.016 1.536 3.264H93.981l1.248-11.903 11.424.095z"
          className="p3-fil22"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          d="M7989 3176L8417 3186 8350 4342 7915 4342z"
          className="p3-fil34"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
          transform="matrix(.096 0 0 .096 -667.373 -95.97)"
        ></path>
        <path
          fillRule="evenodd"
          d="M8219 3386L8297 3187 8291 3184 8212 3385 8149 4342 8156 4343z"
          className="p3-fil35"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
          transform="matrix(.096 0 0 .096 -667.373 -95.97)"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M113.469 137.496s1.152 4.032 3.84 5.856c0-.192.096-7.392.096-7.392l-4.032 1.536z"
          className="p3-fil22"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M121.148 120.696c-.768.192-1.535.576-2.207 1.056-6.432 4.32-4.8 15.072-.672 20.544 2.304 3.072 6.047 4.896 9.695 4.224 5.376-.96 7.968-6.432 7.872-11.712-.096-3.936-1.536-7.872-4.32-10.656-2.688-2.784-6.72-4.512-10.368-3.456z"
          className="p3-fil36"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M117.02 138.936c-1.151.768-2.88.864-4.031.192-1.248-.672-2.016-2.112-2.112-3.552-.096-1.344.48-2.688 1.536-3.264 1.056-.576 2.688-.288 3.36.864z"
          className="p3-fil36"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M116.157 135.384l-2.208 18.24c-.48 3.36 1.824 6.527 5.088 7.103 3.84.768 7.487-2.112 7.68-5.952l.96-17.087z"
          className="p3-fil36"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M127.004 149.208l.192-2.496s-5.28.672-8.927-4.32c0 0 1.727 5.184 8.735 6.816z"
          className="p3-fil26"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M125.852 135.192c-.288-.288-.768.096-.48.384.576.576 1.536-.096.96-.768-.576-.672-1.536.192-1.056.768.48.672 1.536-.192.864-.768-.672-.576-1.344.576-.576.96.384.192.672-.384.288-.576z"
          className="p3-fil13"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M127.484 132.312c-1.344-.192-2.784-.192-4.128-.096-.576.096-.48.96.096.96 1.248-.096 2.592-.096 3.936.096.576.096.768-.864.096-.96z"
          className="p3-fil13"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M134.012 134.232c-.288-.288-.768.096-.48.384.576.576 1.536-.096.96-.768-.576-.672-1.536.192-1.056.768.48.672 1.536-.192.864-.768-.672-.576-1.344.576-.576.96.384.192.672-.384.288-.576z"
          className="p3-fil13"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M130.46 137.88l.864-1.056.096.48c-.384-.288-.576-.576-.672-.864a1.852 1.852 0 01-.288-.96c.288.576.768 1.152 1.248 1.248l.384.096-.288.384-1.152.672h-.192v-.096z"
          className="p3-fil28"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M130.46 137.88l.864-1.056.096.48c-.384-.288-.576-.576-.672-.864a1.852 1.852 0 01-.288-.96c.288.576.768 1.152 1.248 1.248l.384.096-.288.384-1.152.672h-.192v-.096z"
          className="p3-fil28"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M131.42 131.928c1.152-.384 2.4-.576 3.648-.672.576 0 .672.864.096.864a21.642 21.642 0 00-3.456.576c-.48.192-.864-.672-.384-.864z"
          className="p3-fil13"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M114.717 136.248c-.288 0-.576-.096-.768-.288-.192-.192-.288-.384-.288-.48 0-.288.288-.576.672-.672.192 0 .288-.192.192-.384 0-.192-.192-.288-.384-.192a1.43 1.43 0 00-1.152 1.152v.096c0 .384.192.672.48.96.288.288.672.384 1.056.384.192 0 .288-.096.288-.288 0-.192-.096-.288-.288-.288z"
          className="p3-fil28"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M125.756 147c-3.072-.384-9.311-2.496-10.175-12.672l1.824-1.536s4.991 9.696 18.143 4.8c0 0-.672 7.68-6.816 9.216-.96.288-2.016.288-2.976.192z"
          className="p3-fil22"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M128.636 140.184l2.784-.096s-1.152 2.4-2.784.096z"
          className="p3-fil1"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M119.325 125.976s7.007-5.568 13.151-.768c0 0-4.512-7.487-11.615-6.047-7.2 1.44-8.832 8.735-8.544 13.247 0 0 2.304-.768 3.36.864v1.152s1.824 1.536 1.824 1.344c0-.192 4.8-6.72 1.92-9.792z"
          className="p3-fil22"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M119.325 125.976s8.16 2.976 14.303.96c0 0-2.016-6.144-10.464-5.28-8.447.864-3.84 4.32-3.84 4.32z"
          className="p3-fil22"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M169.243 165.911l-8.256-1.248c-1.344-.192-2.304-1.536-2.112-2.88l2.592-17.183c.192-1.344 1.536-2.304 2.88-2.112l8.256 1.248c1.344.192 2.304 1.536 2.112 2.88l-2.592 17.183c-.192 1.344-1.536 2.304-2.88 2.112z"
          className="p3-fil18"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M136.796 163.703c1.824 5.088 3.552 11.52 4.128 18.432 1.344 16.031-.48 28.99-.48 28.99l-42.623 1.249 2.496-47.23c13.824-1.057 25.151-2.017 36.48-1.537z"
          className="p3-fil37"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M106.269 167.351s4.128-16.223 4.416-16.415c0 0 1.536-.48 3.36-.48.576 1.056 2.016 2.496 6.24 2.592 4.895.192 5.951-1.344 6.623-2.112 5.28 1.824 9.408 3.263 9.984 10.175.288 3.744-.096 2.208 1.344 19.2l.672 8.447-36.479-.192 3.744-21.215z"
          className="p3-fil37"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M166.94 201.43c-15.168 5.472-29.28-17.567-29.28-17.567l13.536-11.328 11.135 14.496 2.88-27.648 8.16-.672s2.88 39.36-6.432 42.72z"
          className="p3-fil38"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M172.891 167.64c-2.304 0-4.704 0-7.008-.097v-1.056l-.288-2.784s-1.92-5.472-4.32-6.624c.096-.384.576-.864 1.152-.864 2.016.192 3.264 2.016 3.264 2.016s.96-9.503 1.728-9.12c.864.385.864 5.376.864 5.376s.768-7.583 1.44-6.911c.288.288 0 0 .384 6.623 0 0 1.44-5.855 1.92-4.8.48 1.345.192 5.76.192 5.76s1.152-4.511 1.536-3.647c.288.864-.96 12.96-.96 12.96s0 1.247.096 2.975z"
          className="p3-fil38"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M126.908 150.936s9.6-1.44 31.103 28.223l-18.623 13.727-12.384-41.95z"
          className="p3-fil37"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M140.06 173.783l.768 17.663c0 .192.192.288.384.288s.288-.192.288-.384l-.768-17.663c0-.192-.192-.288-.384-.288s-.288.192-.288.384z"
          className="p3-fil39"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M159.067 250.485h-42.43c-1.728 0-3.072-1.344-3.072-3.072v-30.911c0-1.728 1.344-3.072 3.072-3.072h42.43a3.033 3.033 0 013.072 3.072v30.91a3.033 3.033 0 01-3.072 3.073z"
          className="p3-fil18"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M146.492 216.214v-.672h-14.976v-3.264c0-2.016.768-3.744 2.112-5.088a7.255 7.255 0 015.088-2.112c2.016 0 3.744.768 5.088 2.112 1.248 1.344 2.112 3.072 2.112 5.088v3.936h.672v-.672.672h.672v-3.936c0-4.704-3.84-8.448-8.448-8.448-4.704 0-8.448 3.84-8.448 8.448v4.608h16.992v-.672h-.672z"
          className="p3-fil18"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M137.18 199.798c-.768 0-1.44.096-2.016.192l-32.83-2.784.191-9.023s-6.624-.96-13.344-.288c0 0-4.607 17.759 4.608 20.735 7.584 2.4 35.807-.096 40.895-.576.768.192 1.728.384 2.592.384 3.648 0 6.624-1.92 6.624-4.32 0-2.4-2.976-4.32-6.624-4.32z"
          className="p3-fil38"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M113.277 150.648s-16.512-2.112-25.824 37.535c0 0 7.008.192 15.936.383l9.792-37.918z"
          className="p3-fil37"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M102.813 188.566l.48-11.807c0-.192-.096-.384-.288-.384-.192 0-.384.096-.384.288l-.48 11.808c0 .191.096.383.288.383.192 0 .384-.096.384-.288z"
          className="p3-fil39"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
      </g>
    </svg>
  );
}
